<template>
	<div class="relative">
		<Transition
			enterActiveClass="transition-opacity duration-500"
			leaveActiveClass="transition-opacity duration-500"
			enterFromClass="opacity-0"
			leaveToClass="opacity-0"
		>
			<div
				class="absolute top-0 right-0 left-0 flex items-center justify-center"
				v-if="loading"
			>
				<LoaderIcon class="text-separator-secondary h-10 w-10" />
			</div>
		</Transition>
		<div
			class="transition-all duration-500"
			:class="{ 'pointer-events-none mt-10 opacity-0': loading }"
		>
			<slot />
		</div>
	</div>
</template>
<script setup lang="ts">
import LoaderIcon from '@/assets/icons/loader.svg'

defineProps<{
	loading: boolean
}>()
</script>
